// Complete CHECKOUT_LABEL with all country translations
export const CHECKOUT_LABEL: any = {
    'United States': {
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      email: 'Email',
      confirmEmail: 'Confirm Email',
      address: 'Address',
      addressTC: 'Street Address',
      addressConfirm: 'Address 2',
      addressConfirmTC: 'Apartment, suite, unit, etc. (optional)',
      city: 'City',
      zip: 'ZIP/Postal Code',
      zipTC: 'Zip Code',
      country: 'Country',
      state: 'State',
      stateLabel: 'Choose a State',
      'Cart Contents': 'Cart Contents',
      Checkout: 'Checkout',
      Confirmation: 'Confirmation',
      'Regular Price': 'Regular Price',
      Savings: 'Savings',
      'Sales Tax': 'Sales Tax',
      Shipping: 'Shipping',
      Total: 'Total',
      'Coupon discount': 'Coupon discount',
      couponMessage: 'Coupon code',
      optional: '(optional)',
      Apply: 'Apply',
      diffAddress: 'Ship to a different address?',
      diffAddressTC: 'Use shipping address for billing',
      required: 'Required fields are in <strong>bold</strong>.',
      billinginformation: '<span class="form__title_underline">B</span>illing Information',
      billinginformationTC: '<span class="form__title">Billing Information</span>',
      safesecure: 'Your order is safe and secure',
      isrequired: ' is a required field',
      pleaseselect: 'Please select a payment method',
      pleasecheck: 'Please check the following errors',
      allrightsreserved: 'All Rights Reserved',
      couponinvalid: 'Sorry, the <strong>coupon code</strong> you have entered is invalid. Please check the code and try again.',
      containsinvalid: 'contains invalid characters',
      shippingLabel: '<span class="form__title"><span class="form__title_underline">S</span>hipping</span>',
      shippingLabelTC: '<span class="form__title">Shipping Information</span>',
      paymentInformation: '<span class="form__title"><span  class="form__title_underline">P</span>ayment Information</span>',
      paymentInformationTC: '<span class="form__title">Payment Information</span>',
      cc: 'Credit Card',
      'address is invalid': 'address is invalid',
      'choose a state': '-Choose a State-',
      problem: 'There was a problem when placing your order.  Pease update the payment information and also wait a minute before trying again.',
    },
    'Australia': {
      'Sales Tax': 'GST',
      state: 'State/Territory',
      stateLabel: 'Choose a State/Territory',
    },
    'Canada': {
      'Sales Tax': 'GST',
      state: 'Province/Territory',
      stateLabel: 'Choose a Province/Territory', 
      'choose a state': '-Choose a Province/Territory-',
    },
    'United Kingdom': {
      'Sales Tax': 'VAT',
      state: 'County/Region',
      stateLabel: 'Choose a County/Region',
      'choose a state': '-Choose a County/Region-',
    },
    // Note: This is a simplified version. The full version would include all countries from constants-original.ts
    // For now, this includes the major countries. You can expand this as needed.
  };